<div edsRow>
  <!-- Share Price -->
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="fundSummaryInfo.nav && calcTypeVisibility.showMarketPrice"
  >
    <div edsFlexbox>
      <small class="small">
        {{ "products.as-of" | translate: brConfig.fundId }}
        {{ fundSummaryInfo.nav.navAsOfDate }}
      </small>
    </div>

    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'products.SHARE_PRICE' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.marketPriceValue"
        caveatPlacement="Fund Summary:NavOverview"
        [valueTextLarge]="true"
      ></eds-summary-item>
    </div>
  </div>

  <!-- Nav -->
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="fundSummaryInfo.nav"
  >
    <div edsFlexbox>
      <small class="small" *ngIf="!calcTypeVisibility.showMarketPrice">
        {{ "products.as-of" | translate: brConfig.fundId }}
        {{ fundSummaryInfo.nav.navAsOfDate }}
      </small>
      <small class="small" *ngIf="calcTypeVisibility.showMarketPrice"
        >&nbsp;</small
      >
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'pds.NAV_VALUE' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.navValue"
        [supplementaryText]="
          calcTypeVisibility.showNavChangePercentage
            ? fundSummaryInfo.nav.navChangeValue +
              ' (' +
              fundSummaryInfo.nav.navChangePercentage +
              ')'
            : ''
        "
        caveatPlacement="Fund Summary:NavOverview"
        [valueTextLarge]="true"
      ></eds-summary-item>
    </div>
  </div>
  <!-- Discount -->
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="fundSummaryInfo.nav && calcTypeVisibility.showPremiumDiscount"
  >
    <div edsFlexbox>
      <small class="small">&nbsp;</small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'products.DISCOUNT' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.premiumDiscountPct"
        caveatPlacement="Fund Summary:NavOverview"
        [valueTextLarge]="true"
      ></eds-summary-item>
    </div>
  </div>

  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="fundSummaryInfo.nav && calcTypeVisibility.showNavChangeValue"
  >
    <div edsFlexbox>
      <small class="small">&nbsp;</small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'pds.NAV_CHANGE_VALUE' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.navChangeValue"
        [supplementaryText]="navChangePercentage"
        valueDirection="{{ fundSummaryInfo.nav.changeDirection }}"
        caveatPlacement="Fund Summary:NavChangeOverview"
        [valueTextLarge]="true"
      ></eds-summary-item>
    </div>
  </div>
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="calcTypeVisibility.showPop && fundSummaryInfo?.nav?.popValue"
  >
    <div edsFlexbox>
      <small class="small">&nbsp;</small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'pds.APPLICATION_PRICE' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.popValue"
        caveatPlacement="Fund Summary:ApplicationPriceOverview"
        [valueTextLarge]="true"
      ></eds-summary-item>
    </div>
  </div>
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="
      calcTypeVisibility.showRedemptionPrice &&
      fundSummaryInfo?.nav?.redemptionPrice
    "
  >
    <div edsFlexbox>
      <small class="small">&nbsp;</small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'pds.REDEMPTION_PRICE' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.redemptionPrice"
        caveatPlacement="Fund Summary:RedemptionPriceOverview"
        [valueTextLarge]="true"
      ></eds-summary-item>
    </div>
  </div>
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="
      fundSummaryInfo?.nav?.marketToMarketNav &&
      calcTypeVisibility.showMarketToMarketNav
    "
  >
    <div edsFlexbox>
      <small class="small">&nbsp;</small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'pds.MTM_NAV' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.marketToMarketNav"
        caveatPlacement="Fund Summary:MarketToMarketNav"
      ></eds-summary-item>
    </div>
  </div>
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="
      fundSummaryInfo?.nav?.marketToMarketNavChg &&
      calcTypeVisibility.showMarketToMarketNav
    "
  >
    <div edsFlexbox>
      <small class="small">&nbsp;</small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        [title]="'pds.MTM_NAV_CHG' | translate: brConfig.fundId"
        [val]="fundSummaryInfo.nav.marketToMarketNavChg"
        caveatPlacement="Fund Summary:MarketToMarketNavChg"
      ></eds-summary-item>
    </div>
  </div>
  <div
    edsCol
    [columnNumbers]="{ s: 2, m: 2, l: 2 }"
    *ngIf="
      showRatings &&
      fundSummaryInfo?.ratings?.morningStarRatingOverall &&
      fundSummaryInfo?.ratings?.morningStarRatingOverall !== ''
    "
  >
    <div edsFlexbox>
      <small class="small">
        {{ "products.as-of" | translate: brConfig.fundId }}
        {{ fundSummaryInfo.ratings.asOfDate }}
      </small>
    </div>
    <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
      <eds-summary-item
        [theme]="componentTheme"
        *ngIf="showMSRating"
        theme="morningstar"
        [title]="'products.ratings-title' | translate"
        [supplementaryText]="fundSummaryInfo.ratings.morningStarCategory"
        caveatPlacement="Fund Summary:RatingsOverview"
        [tooltip]="'products.ratings-title-tooltip' | translate"
      >
        <eds-link-item
          href="/"
          [hasIcon]="true"
          type="new-window"
          [stopNavigation]="true"
          [title]="'products.ms-view-details' | translate"
          (onLinkClick)="viewDetails()"
          [theme]="componentTheme"
        ></eds-link-item>
        <ng-container *ngTemplateOutlet="rating"></ng-container>
      </eds-summary-item>
      <eds-summary-item
        *ngIf="!showMSRating"
        theme="morningstar"
        [title]="'products.ratings-title' | translate"
        [supplementaryText]="fundSummaryInfo.ratings.morningStarCategory"
        caveatPlacement="Fund Summary:RatingsOverview"
      >
        <ng-container *ngTemplateOutlet="rating"></ng-container>
      </eds-summary-item>
    </div>
  </div>
</div>

<ng-template #rating>
  <eds-rating
    [rating]="fundSummaryInfo.ratings?.morningStarRatingOverall"
    size="normal"
    [isHybrid]="fundSummaryInfo.ratings.morningStarOverallHybrid"
    [title]="'products.morningstar-review' | translate"
  ></eds-rating>
  <eds-icon
    *ngIf="fundSummaryInfo.ratings.morningStarOverallHybrid"
    type="info"
    size="small"
    tooltipPositionDefault="bottom"
    edsTooltip
    [analyticsName]="'products.ratings-title' | translate"
    tooltipType="large"
    [tooltipContent]="'products.morningstar-tooltip' | translate"
  ></eds-icon>
</ng-template>

<!-- TODO: preview block doesn't seem to be used? -->
<ng-template #previewBlock>
  <ng-container>
    <div edsRow>
      <!--Skeleton loader-->
      <div
        edsCol
        [columnNumbers]="{ s: 2, m: 2, l: 2 }"
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
      >
        &nbsp;
        <div class="small">&nbsp;</div>
        <eds-summary-item [theme]="componentTheme" theme="dark"
          >&nbsp;</eds-summary-item
        >
      </div>
      <div
        edsCol
        [columnNumbers]="{ s: 2, m: 2, l: 2 }"
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
      >
        &nbsp;
        <small edsSpacing="xs">&nbsp;</small>
        <eds-summary-item [theme]="componentTheme" theme="dark"
          >&nbsp;</eds-summary-item
        >
      </div>
      <div
        edsCol
        [columnNumbers]="{ s: 2, m: 2, l: 2 }"
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
      >
        &nbsp;
        <div class="small">&nbsp;</div>
        <eds-summary-item [theme]="componentTheme" theme="dark">
          <eds-icon size="normal" edsPadding edsPaddingRight="sm"
            >&nbsp;</eds-icon
          >
        </eds-summary-item>
      </div>
    </div>
  </ng-container>
</ng-template>

<eds-simple-modal
  [modalId]="ModalId['Morningstar_Modal']"
  [showHeader]="false"
  [showFooter]="false"
  size="large"
  attr.aria-label="{{ 'common.close' | translate }}"
>
  <div modal-body>
    <ft-morning-star-details
      *ngIf="fundSummaryInfo?.ratings"
      [ratingData]="fundSummaryInfo.ratings"
    ></ft-morning-star-details>
  </div>
</eds-simple-modal>
